import { assertIsNumberOrNull } from '../../../../helpers/numberHelpers';
import { DownlossTypeCode } from '../../quote-or-design-form/rooms/heatLoss/downlossTypeCode';
import { UnitFloorElementFormModel } from '../../quote-or-design-form/units/heatLoss/unitFloorElementFormModel';

export type CreateUpdateUnitFloorElementDto = {
  floorElementId: number | null;
  displayIndex: number;
  name: string;
  floorThermalTransmittance: number | null;
  downlossTypeCode: DownlossTypeCode;
  defaultTemperatureBelowInDegreesCelsius: number | null;
};

export const mapUnitFloorElementFormModelToDto = (
  formModel: UnitFloorElementFormModel,
  displayIndex: number,
): CreateUpdateUnitFloorElementDto => ({
  floorElementId: formModel.floorElementId,
  displayIndex,
  name: formModel.name,
  floorThermalTransmittance: assertIsNumberOrNull(formModel.floorThermalTransmittance),
  downlossTypeCode: formModel.downlossTypeCode,
  defaultTemperatureBelowInDegreesCelsius: assertIsNumberOrNull(formModel.defaultTemperatureBelowInDegreesCelsius),
});
